import { render, staticRenderFns } from "./customerData.vue?vue&type=template&id=759c04b8&scoped=true&"
import script from "./customerData.vue?vue&type=script&lang=js&"
export * from "./customerData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759c04b8",
  null
  
)

export default component.exports